<template>
    <div class="swiper-panel" :class="rootClasses">
        <div class="swiper-panel--row grid--row">
            <div class="swiper-panel--col">
                <div class="swiper-panel--outer-wrapper swiper-container" ref="slider">
                    <div class="swiper-panel--inner-wrapper swiper-wrapper">
                        <slot/>
                    </div>
                    <div class="swiper-panel--nav" v-if="isSwiperEnabled">
                        <button class="swiper-panel--nav-btn swiper-panel--nav-btn__next swiper-button-next"/>
                        <button class="swiper-panel--nav-btn swiper-panel--nav-btn__prev swiper-button-prev"/>
                    </div>
                    <div class="swiper-pagination swiper-panel--pagination"
                            v-if="isSwiperEnabled"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper';
    import $ from 'bianco.query';
    import { loadImages } from 'bianco.images-loader';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import { mapState } from 'vuex';

    export default {
        mixins: [
            bemMixin('swiper-panel'),
        ],
        props: {
            itemCount: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                swiper: null,
            };
        },
        computed: {
            ...mapState('user-region', ['userRegion']),
            rootClasses() {
                return [
                    this.bemFacets,
                    this.bemAdd(this.layout),
                ];
            },
            layout() {
                switch (this.itemCount) {
                    case 0:
                    case 1:
                        return 'single-col';
                    case 2:
                        return 'two-cols';
                    case 3:
                        return 'three-cols';
                    default:
                        return 'multiple-cols';
                }
            },
            isSwiperEnabled() {
                return this.itemCount > 3;
            },
        },
        methods: {
            updateSwiper() {
                if (this.swiper && this.isVisible()) {
                    this.swiper.update();
                }
            },
            isVisible() {
                return this.$el.offsetHeight > 0;
            },
        },
        watch: {
            // swiper should be updated whenever the userRegion will change
            // it might be that some sliders are hidden to the user and get displayed only when the user changes region
            userRegion() {
                this.$nextTick(this.updateSwiper);
            },
        },
        beforeDestroy() {
            if (this.swiper) {
                this.swiper.destroy();
                this.swiper = null;
            }
        },
        mounted() {
            if (!this.isSwiperEnabled) {
                return;
            }
            const images = $('img', this.$el);
            const config = {
                allowTouchMove: true,
                simulateTouch: true,
                slidesPerView: 1,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                breakpoints: {
                    // >=lg
                    992: {
                        slidesPerView: 3,
                        simulateTouch: false,
                    },
                },
            };

            this.swiper = new Swiper(this.$refs.slider, config);

            // update swiper when all the images are completely loaded
            loadImages(images).then(this.updateSwiper);
        },
    };
</script>
